export const OnsiteInterview = {
  STORE: 'ONSITE_INTERVIEW_STORE',
  DELETE: 'ONSITE_INTERVIEW_DELETE',
  EDIT: 'ONSITE_INTERVIEW_EDIT',
  CLEAR: 'ONSITE_INTERVIEW_CLEAR',
};

export const HasPostings = {
  SET: 'HAS_POSTINGS_SET',
};
